// Footer link/column data extracted from Footer.js for clarity & testability.

export const PLATFORM_LINKS = [
  ['MCX Core', '/platform/mcx-core'],
  ['MCX BSS', '/platform/mcx-bss'],
  ['MCX Activate', '/platform/mcx-activate'],
  ['MCX Marketplace', '/platform/mcx-marketplace'],
];

export const SOLUTIONS_LINKS = [
  ['Banks & Fintechs', '/solutions/banks-and-fintechs'],
  ['Consumer Brands', '/solutions/consumer-brands'],
  ['Enterprise & Corporate', '/solutions/enterprise-and-corporate-affinity'],
  ['Diaspora & Affinity', '/solutions/diaspora-and-affinity'],
  ['IoT & M2M', '/solutions/iot-and-m2m'],
  ['Foreign MVNO Landing', '/solutions/foreign-mvno-landing'],
];

export const ABOUT_LINKS = [
  ['About MobileCoreX', '/about'],
  ['Who we are', '/about/who-we-are'],
  ['What we do', '/about/what-we-do'],
  ['How we do it', '/about/how-we-do-it'],
  ['Leadership', '/about/leadership'],
  ['Company facts', '/about/company-facts'],
];

export const REGULATORY_LINKS = [
  ['Regulatory Overview', '/regulatory'],
  ['NCC MVNO Framework', '/regulatory/ncc-mvno-framework'],
  ['NDPA & Data Protection', '/regulatory/ndpa-and-data-protection'],
  ['SIM Registration & KYC', '/regulatory/sim-registration-and-kyc'],
  ['Privacy Policy', '/legal/privacy-policy'],
  ['Terms of Service', '/legal/terms-of-service'],
  ['Accessibility', '/legal/accessibility'],
];

export const SOCIAL_LINKS = [
  ['LinkedIn', 'https://ng.linkedin.com/company/mobilecorex'],
  ['X (Twitter)', 'https://x.com/mobilecorex'],
  ['Instagram', 'https://instagram.com/mobilecorex'],
];
